/**
 * Crea los ultimos números ganadores por defecto cuando uno recién entra al juego
 * @param {*} scene 
 */
export function crearUltimosNumeros(scene) {

  const ultimosNumeros = [
    [null, null],
    [null, null],
    [null, null],
    [null, null],
    [null, null],
  ];

  scene.imagenesUltimosNumeros = ultimosNumeros;

  scene.imagenesUltimosNumeros[0][0] = scene.add.image(
    222,
    54,
    "ultimoNumero0"
  );
  scene.imagenesUltimosNumeros[0][1] = 0;
  scene.imagenesUltimosNumeros[1][0] = scene.add.image(
    294,
    54,
    "ultimoNumero0"
  );
  scene.imagenesUltimosNumeros[1][1] = 0;
  scene.imagenesUltimosNumeros[2][0] = scene.add.image(
    366,
    54,
    "ultimoNumero0"
  );
  scene.imagenesUltimosNumeros[2][1] = 0;
  scene.imagenesUltimosNumeros[3][0] = scene.add.image(
    438,
    54,
    "ultimoNumero0"
  );
  scene.imagenesUltimosNumeros[3][1] = 0;
  scene.imagenesUltimosNumeros[4][0] = scene.add.image(
    510,
    54,
    "ultimoNumero0"
  );
  scene.imagenesUltimosNumeros[4][1] = 0;
}